import React, { useEffect, useState } from 'react';
import SummaryApi from '../../../components/common/index';
import { FiTrendingUp, FiEye, FiBookOpen, FiClock, FiBarChart2 } from 'react-icons/fi';
import './BlogVisitReport.css';

const BlogVisitReport = () => {
    const [stats, setStats] = useState({
        totalViews: 0,
        uniqueBlogs: 0,
        topBlogId: "N/A",
        list: []
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReport = async () => {
            try {
                const response = await fetch(SummaryApi.getVisitReport.url);
                const result = await response.json();
                const rawData = result.data || result;

                if (Array.isArray(rawData) && rawData.length > 0) {
                    processData(rawData);
                }
            } catch (error) {
                console.error("Error fetching report:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchReport();
    }, []);

    // Helper function to turn individual visits into "Counts per Blog"
    const processData = (data) => {
        const aggregation = data.reduce((acc, visit) => {
            const id = visit.blog_id;
            if (!acc[id]) {
                acc[id] = { blog_id: id, count: 0, lastVisit: visit.created_at };
            }
            acc[id].count += 1;
            // Update last visit if this one is newer
            if (new Date(visit.created_at) > new Date(acc[id].lastVisit)) {
                acc[id].lastVisit = visit.created_at;
            }
            return acc;
        }, {});

        const sortedList = Object.values(aggregation).sort((a, b) => b.count - a.count);
        
        setStats({
            totalViews: data.length,
            uniqueBlogs: sortedList.length,
            topBlogId: sortedList[0]?.blog_id || "N/A",
            list: sortedList
        });
    };

    if (loading) return <div className="report-loader">
        <div className="spinner"></div>
        <p>Analyzing Traffic...</p>
    </div>;

    return (
        <div className="report-wrapper">
            <header className="report-header">
                <div>
                    <h1>Analytics Dashboard</h1>
                    <p>Performance metrics for your editorial content</p>
                </div>
                <button className="refresh-btn" onClick={() => window.location.reload()}>Refresh Data</button>
            </header>

            {/* Summary Stats Cards */}
            <div className="stats-grid">
                <div className="stat-card highlight">
                    <div className="stat-icon"><FiEye /></div>
                    <div className="stat-content">
                        <span className="stat-label">Total Views</span>
                        <h2 className="stat-value">{stats.totalViews.toLocaleString()}</h2>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon"><FiBookOpen /></div>
                    <div className="stat-content">
                        <span className="stat-label">Active Blogs</span>
                        <h2 className="stat-value">{stats.uniqueBlogs}</h2>
                    </div>
                </div>
                <div className="stat-card">
                    <div className="stat-icon"><FiTrendingUp /></div>
                    <div className="stat-content">
                        <span className="stat-label">Top Performer</span>
                        <h2 className="stat-value">Post #{stats.topBlogId}</h2>
                    </div>
                </div>
            </div>

            {/* Aggregated Table */}
            <div className="report-card main-table-card">
                <div className="card-header">
                    <FiBarChart2 /> <h2>Content Popularity</h2>
                </div>
                <div className="table-container">
                    <table className="custom-table">
                        <thead>
                            <tr>
                                <th>Blog Content</th>
                                <th>Popularity</th>
                                <th>Total Visitors</th>
                                {/* <th>Last Activity</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {stats.list.length > 0 ? stats.list.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="blog-info">
                                            <span className="blog-id-tag">#{item.blog_id}</span>
                                            <span className="blog-name-placeholder">Blog Post Insight</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="progress-mini">
                                            <div 
                                                className="progress-fill" 
                                                style={{ width: `${(item.count / stats.totalViews) * 100}%` }}
                                            ></div>
                                        </div>
                                    </td>
                                    <td>
                                        <span className="visitor-count">
                                            {item.count.toLocaleString()}
                                        </span>
                                    </td>
                                    {/* <td>
                                        <div className="last-visit">
                                            <FiClock /> {new Date(item.lastVisit).toLocaleDateString()}
                                        </div>
                                    </td> */}
                                </tr>
                            )) : (
                                <tr><td colSpan="4" className="empty-state">No traffic data available yet.</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default BlogVisitReport;